import api from "../../../../app/api";

export interface OrderListItem {
  id: number;
  price: string;
  first_name: string;
  last_name: string;
  street: string;
  city: string;
  country: string;
  state: string;
  zip: string;
  phone: string;
  created_at: string;
  bundle_name: string;
  bundle_type: string;
}

export type OrderListFormItem = {} & OrderListItem;

export function getOrderListService() {
  return api.getService<OrderListFormItem, OrderListItem>(
    "order"
  );
}